import { render, staticRenderFns } from "./EditDialogMainContainer.vue?vue&type=template&id=5ab0563f"
import script from "./EditDialogMainContainer.vue?vue&type=script&lang=js"
export * from "./EditDialogMainContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports